export const fileSize = 20 * 1000000; // 20MB en KB
export const validFileExtensions = ['jpg', 'png', 'tiff', 'pdf', 'doc', 'docx'];
